import QvPage from '../view/loading/pages/qv/QvPage';
import DaishinPage from '../view/loading/pages/daishin/DaishinPage';
import HyundairsPage from '../view/loading/pages/hyundairs/HyundairsPage';
import BTBMarket from '../view/loading/pages/btb/BTBMarket';
import { COMPANY } from '../const/company';

// 개발자 진입(/init?target=<key>) 설정.
// 회사 지식(id·이름·전화·시나리오)의 단일 출처는 const/company.js 이고,
// 여기서는 회사별 로딩 화면 매핑만 더한다.
const toTargetConfig = (company, LoadingComponent) => ({
  id: company.id,
  companyName: company.name,
  companyTel: company.tel,
  value: company.id,
  label: company.name,
  ...(company.sid ? { sid: company.sid } : {}),
  ...(company.teamId ? { team: { id: company.teamId } } : {}),
  LoadingComponent,
});

const TARGET_CONFIG_MAP = {
  [COMPANY.QV.key]: toTargetConfig(COMPANY.QV, QvPage),
  [COMPANY.DAISHIN.key]: toTargetConfig(COMPANY.DAISHIN, DaishinPage),
  [COMPANY.HYUNDAIRS.key]: toTargetConfig(COMPANY.HYUNDAIRS, HyundairsPage),
};

const DEFAULT_LOADING_COMPONENT = BTBMarket;

export function getTargetConfig(targetKey) {
  if (!targetKey) return null;
  return TARGET_CONFIG_MAP[targetKey] || null;
}

export function getLoadingComponent(targetConfig) {
  return targetConfig?.LoadingComponent || DEFAULT_LOADING_COMPONENT;
}

export function listTargetKeys() {
  return Object.keys(TARGET_CONFIG_MAP);
}

export function getAllTargets() {
  return Object.entries(TARGET_CONFIG_MAP).map(([key, value]) => ({
    key,
    ...value,
  }));
}
